import React, { useState } from 'react';
import { keyBoardAccessibilityAttributes } from '../../../../../utils/GeneralUtils';
import ConfettiModal from './ConfettiModal';
import NewMemberModal from './NewMemberModal';

const RegisterButton = props => {
  const [show, setShowModal] = useState(false);
  const showModal = () => setShowModal(true);
  const hideModal = () => setShowModal(false);
  const modalOptions = { show, showModal, hideModal }

  return(
    <>
      {
        show && <>
          { props.confettiModal && <ConfettiModal modalOptions={ modalOptions } { ...props } /> }
          { props.newMemberModal && <NewMemberModal modalOptions={ modalOptions } { ...props } /> }
        </>
      }

      <a
        className='btn btn-primary btn-rounded-5'
        onClick={ showModal }
        { ...keyBoardAccessibilityAttributes }
      >
        { props.label }
      </a>
    </>
  )
};

export default RegisterButton;